import {Formik} from 'formik';
import {Button, Form} from "react-bootstrap";
import {Link} from "react-router-dom";
import AuthApi from "../api/AuthApi";
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { addSuccessMessage } from '../../../store/ActionAlertsStore';

export default function RegisterForm(props) {
    const intl = useIntl();
    const dispatch = useDispatch();
    const register = (username, email, password) => {
        return AuthApi.register(username, email, password)
            .then((data) => {
                dispatch(addSuccessMessage(intl.formatMessage({id:"you_registered successfully"})))
                window.location.href = "/login";
                window.location.reload();
            })
    }
    return (
        <>
            <div className="peers ai-s fxw-nw h-100vh">
            <div className="login-bg d-n@sm- peer peer-greed h-100 pos-r bgr-n bgpX-c bgpY-c bgsz-cv">
                {/* <div className="pos-a centerXY">
                <div className="bgc-white bdrs-50p pos-r" style="width: 120px; height: 120px;">
                    <img className="pos-a centerXY" src="assets/static/images/logo.png" alt=""/>
                </div>
                </div> */}
            </div>
            <div className="col-12 col-md-4 peer pX-40 pY-80 h-100 bgc-white scrollable pos-r" >
                <h4 className="fw-300 c-grey-900 mB-40">
                    <FormattedMessage id="sign_up"/>
                </h4>
                
                <Formik
                initialValues={{ username:'', email: '', password: '' }}
                validate={values => {
                    const errors = {};

                    if (!values.username) {
                        errors.username = intl.formatMessage({id:"field_required"});
                    }

                    if (!values.password) {
                        errors.password = intl.formatMessage({id:"field_required"});;
                    }

                    if (!values.email) {
                        errors.email = intl.formatMessage({id:"field_required"});;
                    } else if (
                        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                    ) {
                        errors.email = 'Invalid email address';
                    }

                    return errors;
                }}
                onSubmit={(values, { setSubmitting }) => {
                    var result = register(values.username, values.email, values.password)
                    result.finally(() => {
                        setSubmitting(false);
                    })
                }}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleBlur,
                      handleSubmit,
                      isSubmitting,
                      /* and other goodies */
                  }) => (

                    <Form onSubmit={handleSubmit} noValidate={true}>
                        <Form.Group className="mb-3" controlId="formBasicUsername">
                            <Form.Label><FormattedMessage id="username"/></Form.Label>
                            <Form.Control type="text" placeholder="Enter username"
                                          name="username"
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value={values.username}/>
                            {errors.username && touched.username && <Form.Text className="text-danger">
                                {errors.username}
                            </Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label><FormattedMessage id="email"/></Form.Label>
                            <Form.Control type="email" placeholder="Enter email"
                                          name="email"
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value={values.email}/>
                            {errors.email && touched.email && <Form.Text className="text-danger">
                                {errors.email}
                            </Form.Text>}
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label><FormattedMessage id="password"/></Form.Label>
                            <Form.Control type="password"
                                          name="password"
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value={values.password}
                                          placeholder="Password" />
                            {errors.password && touched.password && <Form.Text className="text-danger">
                                {errors.password}
                            </Form.Text>}
                        </Form.Group>
                        <Button variant="primary" type="submit" disabled={isSubmitting}>
                            <FormattedMessage id="sign_up"/>
                        </Button>
                    </Form>
                )}
            </Formik>

            <div>
                <Link to={"/login"}><FormattedMessage id="sign_in"/></Link>
            </div>

            </div>
            </div>
        </>
    )
}